// 设置 rem 函数
export function setRem() {
  // 750 默认大小16px; 750px = 750/16rem ;每个元素px基础上/16
  const htmlWidth = document.documentElement.clientWidth || document.body.clientWidth;
  //得到html的Dom元素
  const htmlDom = document.getElementsByTagName("html")[0];
  //设置根元素字体大小
  const fontSize = Math.min(htmlWidth / (750 / 16), 10);
  htmlDom.style.fontSize = `${fontSize}px`;
}
// 初始化
setRem();
// 改变窗口大小时重新设置 rem
window.onresize = function () {
  setRem();
};
